<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="height"
    :fill="fill"
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z">
    </path>
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 16,
  },
  height: {
    type: [String, Number],
    default: 16,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>